import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSemanticwebComponent } from './simple-icons-semanticweb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSemanticwebComponent ],
    exports:      [ SimpleIconsSemanticwebComponent ],
    bootstrap:    []
})
export class SimpleIconsSemanticwebModule {}
